'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAllFunctions = getAllFunctions;

var _ramda = require('ramda');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// eslint-disable-next-line import/prefer-default-export
function getAllFunctions(object) {
  var chain = [];

  for (var current = Object.getPrototypeOf(object); current; current = Object.getPrototypeOf(current)) {
    chain = (0, _ramda.append)(current, chain);
  }

  var extractFrom = function extractFrom(obj) {
    return (0, _ramda.reduce)(function (memo, key) {
      if ((0, _ramda.is)(Function, obj[key])) {
        return (0, _ramda.merge)(_defineProperty({}, key, obj[key]), memo);
      } else {
        return memo;
      }
    }, {}, Object.getOwnPropertyNames(obj));
  };

  return (0, _ramda.reduce)(function (memo, obj) {
    return (0, _ramda.merge)(extractFrom(obj), memo);
  }, {}, chain);
}